import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LinkedInProfile } from "common/types";

import useIncludedListLeadsMutations from "../../../../datahooks/useIncludedListLeadsMutations";
import { startListLeadsBulkAction } from "../../../../utils";

interface RemoveLeadsProps {
  listId: string;
  selectedLeads: LinkedInProfile[];
  onBack?: () => void;
  onClose: (shouldClearSelection: boolean) => void;
}

export default function RemoveLeads({
  listId,
  selectedLeads,
  onBack,
  onClose,
}: RemoveLeadsProps) {
  const isDesktop = useTwBreakpoint("lg");

  const Header = isDesktop ? DialogHeader : DrawerHeader;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;

  const { removeListLead } = useIncludedListLeadsMutations(listId);

  function removeLeads() {
    startListLeadsBulkAction(
      ({ urn }, abortSignal) =>
        removeListLead({
          urn,
          shouldBlacklist: false,
          abortSignal,
        }),
      selectedLeads,
      (finishedItemsCount) =>
        finishedItemsCount === selectedLeads.length
          ? "Leads removed"
          : `Removing ${finishedItemsCount}/${selectedLeads.length} leads`,
    );
    onClose(true);
  }

  return (
    <>
      <Header
        title="Remove from list?"
        subtitle="Once removed from this list, they will no longer be targeted by any source. You'll need to manually restore them from the excluded tab if you want to include them again"
        onBack={onBack}
      />

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={() => onClose(false)}>
          Cancel
        </Button>
        <Button
          variant="outline-danger"
          disabled={!selectedLeads.length}
          onClick={removeLeads}
        >
          Remove
        </Button>
      </Footer>
    </>
  );
}
